var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-dialog mdc-dialog--open mdc-dialog--loader"},[_c('div',{attrs:{"id":"loaderContainer"}},[_c('img',{attrs:{"src":require("../../../assets/images/loader.gif"),"alt":"loader"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("trans")(_vm.messages)))])]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__wrappdrop"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91edd3b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/loader/components/Loader.vue
// module id = 969
// module chunks = 1